<div class="main-container">
    <div class="poblacion-content row">
        <span style="font-size: larger; font-weight: bold;">
            Consulta mi población
        </span>
        <span style="font-size: medium; color: var(--mid-gray-color);">
            Seleccione consulta a realizar
        </span>
        <br><br>
        <form [formGroup]="frmMain">
            <div class="form-container row">
                <div class="row col-12 col-lg-5">
                    <mat-radio-group formControlName="selectedOption" class="radio-group" (change)="onSelectionChange($event)">
                        <mat-radio-button 
                        color="accent" 
                        [value]="1"
                        appTrackClick
                        [trackData]="{
                            module: 'Mi población',
                            category: 'N/A',
                            submodule: 'Consulta mi población',
                            functionality: 'Consulta contratos con cuotas vencidas',
                            identificadorInteraccion: 'POB_CONSULTA_POB_CONSULTA_CONTRATOS_CUOTA_VENCIDA'
                        }">
                            Contratos con Cuotas Vencidas
                        </mat-radio-button>
                        <mat-radio-button 
                        color="accent" 
                        [value]="2"
                        appTrackClick
                        [trackData]="{
                            module: 'Mi población',
                            category: 'N/A',
                            submodule: 'Consulta mi población',
                            functionality: 'Consulta usuarios activos',
                            identificadorInteraccion: 'POB_CONSULTA_POB_CONSULTA_USUARIOS_ACTIVOS'
                        }"
                        >
                            Usuarios activos
                        </mat-radio-button>
                        <mat-radio-button 
                        color="accent" [value]="3"
                        appTrackClick
                        [trackData]="{
                            module: 'Mi población',
                            category: 'N/A',
                            submodule: 'Consulta mi población',
                            functionality: 'Consulta usuarios retirados',
                            identificadorInteraccion: 'POB_CONSULTA_POB_CONSULTA_USUARIOS_RETIRADOS'
                        }">
                            Usuarios retirados
                        </mat-radio-button>
                    </mat-radio-group>                   
                </div>
                <div class="row col-12 col-lg-7">
                    <div class="col-xs-12 col-md-6 col-lg-4">
                        <button 
                        type="submit" 
                        class="btn btn-primary btn-icon" 
                        (click)="consultar()"
                        >
                            <mat-icon>search</mat-icon><span>CONSULTAR</span>
                        </button>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                        <button class="btn btn-primary btn-icon" (click)="clear()">
                            <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
                        </button>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                        <button 
                        class="btn btn-primary btn-icon" 
                        (click)="exportData()" 
                        appTrackClick
                        [trackData]="{
                            module: 'Mi población',
                            category: 'N/A',
                            submodule: 'Consulta mi población',
                            functionality: 'Exportar consulta',
                            identificadorInteraccion: 'POB_CONSULTA_POB_CONSULTA_EXPORTAR_CONSULTA'
                        }"
                        [disabled]="lockExport || !haveDataToShow">
                            <mat-icon>download</mat-icon><span>EXPORTAR</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <form [formGroup]="frmContratos" *ngIf="this.frmMain.value.selectedOption == 1">
            <div class="row">
                <div class="col-6 col-lg-4">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Edad cartera</mat-label>
                        <mat-select name="walletItem" formControlName="walletAge">
                        @for (walletItem of edadCarteraData; track walletItem) {
                            <mat-option [value]="walletItem.edad_cartera">{{ walletItem.edad_cartera }}</mat-option>
                        }
                        </mat-select>
                        <mat-error *ngIf="hasError( getControlContratos['walletAge'] )">
                            {{ printError( getControlContratos['walletAge'] , {} ) }}
                        </mat-error>
                    </mat-form-field>
                </div>           
                <div class="col-6 col-lg-4">
                <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Columnas</mat-label>

                <mat-select multiple>
                    <mat-option 
                    *ngFor="let col of columnOptions"
                    (onSelectionChange)="onSelectOption($event, col)"
                    [value]="col.key">
                    
                    <mat-pseudo-checkbox 
                        [state]="col.selected ? 'checked' : 'unchecked'"
                        class="mat-option-pseudo-checkbox">
                    </mat-pseudo-checkbox>

                    {{ col.label }}
                    </mat-option>
                </mat-select>
                </mat-form-field>
                </div>
            </div>
        </form>
        <form [formGroup]="frmActivos" *ngIf="this.frmMain.value.selectedOption == 2">
            <div class="row">
                <div class="col-6 col-lg-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Rango edad</mat-label>
                        <mat-select name="ageItem" formControlName="ageRange">
                        @for (ageItem of rangoEdadData; track ageItem) {
                            <mat-option [value]="ageItem.rango_edad">{{ ageItem.rango_edad }}</mat-option>
                        }
                        </mat-select>
                        <mat-error *ngIf="hasError( getControlActivos['ageRange'] )">
                            {{ printError( getControlActivos['ageRange'] , {} ) }}
                        </mat-error>
                    </mat-form-field>
                </div>                
                <div class="col-6 col-lg-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Parentesco real</mat-label>
                        <mat-select name="docItem" formControlName="kinship">
                            @for (docItem of parentescoData; track docItem) {
                                <mat-option [value]="docItem.Parentesco">{{ docItem.Parentesco }}</mat-option>
                            }
                            </mat-select>
                            <mat-error *ngIf="hasError( getControlActivos['kinship'] )">
                                {{ printError( getControlActivos['kinship'] , {} ) }}
                            </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6 col-lg-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Género</mat-label>
                        <mat-select name="docItem" formControlName="gender">
                            @for (docItem of generoData; track docItem) {
                                <mat-option [value]="docItem.Genero">{{ docItem.Genero }}</mat-option>
                            }
                            </mat-select>
                            <mat-error *ngIf="hasError( getControlActivos['gender'] )">
                                {{ printError( getControlActivos['gender'] , {} ) }}
                            </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6 col-lg-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Programa</mat-label>
                        <mat-select name="docItem" formControlName="program">
                            @for (docItem of programaData; track docItem) {
                                <mat-option [value]="docItem.programa">{{ docItem.programa }}</mat-option>
                            }
                            </mat-select>
                            <mat-error *ngIf="hasError( getControlActivos['program'] )">
                                {{ printError( getControlActivos['program'] , {} ) }}
                            </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div *ngIf="haveResponde">            
            <div class="mat-elevation-z8 col-12" [ngClass]="{'hide-table': !haveDataToShow}" style="display: flex;flex-direction: column; min-width: 300px;">
            <div class="table-scroll">
                <table mat-table [dataSource]="dsConsultaPoblacion" matSort>
                    <ng-container [matColumnDef]="dt" *ngFor="let dt of attrData; let i=index">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> {{namesColumns[i]}} </mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="{ 'email-col': dt === 'Email' }">
                            <div class="cell-content cell-wrap">
                                {{ element[dt] }}
                            </div>
                        </mat-cell>                     
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="attrData"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: attrData;"></mat-row>
                </table>
                <mat-paginator [pageSize]="15" [pageSizeOptions]="[15, 20, 30]" [showFirstLastButtons]="true">
                </mat-paginator>
            </div>
            </div>
            <div style="text-align: center;" class="" *ngIf="!haveDataToShow">            
                <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
            </div>
        </div>
        <div *ngIf="!haveResponde" class="message-container">            
            <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
        </div>
    </div>  
</div>
